import PageHeader from "@/components/PageHeader";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ShoppingBag, MessageCircle, Send, ExternalLink } from "lucide-react";

const CATEGORIES = [
  { name: "Teer Tickets Merch", desc: "T-shirts, caps and stickers", tint: "bg-pink-100 text-pink-700" },
  { name: "Meghalaya Souvenirs", desc: "Handmade shawls and bamboo crafts", tint: "bg-amber-100 text-amber-800" },
  { name: "Dream Book & Charts", desc: "Printed dream-number reference", tint: "bg-violet-100 text-violet-700" },
  { name: "Lucky Charms", desc: "Traditional lucky items", tint: "bg-emerald-100 text-emerald-700" },
];

export default function OnlineShopping() {
  return (
    <>
      <PageHeader title="Online Shopping" subtitle="Curated picks for Teer fans" />
      <div className="max-w-xl mx-auto w-full px-4 pb-10 space-y-4">
        <Card className="p-6 border-0 bg-gradient-to-br from-pink-500 to-rose-600 text-white shadow-xl">
          <ShoppingBag className="h-9 w-9 mb-3" />
          <h2 className="font-heading font-black text-2xl">Coming Soon</h2>
          <p className="text-sm text-white/90 mt-1">
            We are curating a selection of Teer-themed products and Meghalaya souvenirs. Message us
            on WhatsApp to be the first to know when the store goes live.
          </p>
          <div className="flex gap-2 mt-4">
            <Button asChild className="rounded-full bg-white text-pink-700 hover:bg-white/90">
              <a href="https://wa.me/916009660070" target="_blank" rel="noopener noreferrer">
                <MessageCircle className="h-4 w-4 mr-2" /> Notify me on WhatsApp
              </a>
            </Button>
          </div>
        </Card>

        <div className="grid grid-cols-2 gap-3">
          {CATEGORIES.map((c) => (
            <Card key={c.name} className="p-4 border-slate-200 hover:shadow-md transition-shadow">
              <span className={`inline-flex h-10 w-10 items-center justify-center rounded-xl ${c.tint} mb-2`}>
                <ExternalLink className="h-5 w-5" />
              </span>
              <div className="font-heading font-bold text-sm text-slate-900">{c.name}</div>
              <div className="text-xs text-slate-500 mt-0.5">{c.desc}</div>
            </Card>
          ))}
        </div>

        <Card className="p-5 border-slate-200 bg-slate-50">
          <div className="text-xs text-slate-500 uppercase font-bold tracking-widest mb-1">
            Merchant enquiry
          </div>
          <div className="text-sm text-slate-700">
            Want to list your product for Teer fans? Reach out via Telegram.
          </div>
          <Button asChild variant="outline" size="sm" className="mt-3 rounded-full">
            <a href="https://t.me/morningteertoday" target="_blank" rel="noopener noreferrer">
              <Send className="h-4 w-4 mr-2" /> Message on Telegram
            </a>
          </Button>
        </Card>
      </div>
    </>
  );
}
